import { useSummary } from "./useSummary";
import { formatMMSS } from "@/lib/formatTime";

export function SummaryTable() {
  const { data, isError } = useSummary();

  return (
    <section className="w-full">
      <h1 className="text-2xl mb-2">Summary</h1>
      <table className="w-full text-left border-collapse">
        <thead>
          <tr className="border-b-2 border-white">
            <th className="font-light text-xl pb-1">State</th>
            <th className="font-light text-xl pb-1">In Queue</th>
            <th className="font-light text-xl pb-1">Hold Time</th>
          </tr>
        </thead>
        <tbody>
          {isError && (
            <tr>
              <td colSpan={3} className="py-2 text-destructive">
                Failed to load summary.
              </td>
            </tr>
          )}
          {data?.map((row) => (
            <tr key={row.state}>
              <td className="text-xl py-1">{row.state}</td>
              <td className="text-xl py-1">{row.callsInQueue}</td>
              <td className="text-xl py-1">{formatMMSS(row.longestHoldTime)}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </section>
  );
}
